import * as React from 'react';
import { SVGProps } from 'react';

const IconMeatballSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 6.5c-.83 0-1.5.67-1.5 1.5S2.17 9.5 3 9.5 4.5 8.83 4.5 8 3.83 6.5 3 6.5zm10 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-5 0c-.83 0-1.5.67-1.5 1.5S7.17 9.5 8 9.5 9.5 8.83 9.5 8 8.83 6.5 8 6.5z" />
  </svg>
);

export default IconMeatballSizeS;
